/**
 * COUDRE Navbar Wave Animations
 * Ported from NavbarWaves.tsx and NavbarMenuWaves.tsx
 */

// ===== SCROLL-RESPONSIVE WAVE (NavbarWaves) =====
(function() {
  var canvas = document.getElementById('navbar-wave');
  if (!canvas) return;

  var ctx = canvas.getContext('2d');
  var width = 0;
  var height = 80;
  var animationId = null;
  var lastScrollTop = 0;
  var lastScrollTime = Date.now();
  var amplitude = 0;
  var phase = 0;
  var isScrolling = false;
  var scrollTimeout = null;
  var MAX_AMPLITUDE = 40;

  function initCanvas() {
    width = window.innerWidth;
    canvas.width = width;
    canvas.height = height;
    ctx.clearRect(0, 0, width, height);
  }

  function drawWave() {
    ctx.clearRect(0, 0, width, height);
    if (amplitude <= 0) return;

    ctx.beginPath();
    var wavelength = width;
    var frequency = 2 * Math.PI / wavelength;
    var step = Math.max(1, Math.floor(width / 200));

    ctx.moveTo(0, 0);

    for (var x = 0; x <= width; x += step) {
      var sinValue = amplitude * Math.sin(frequency * x + phase) / 2;
      var detailValue = amplitude / 3 * Math.sin(2 * frequency * x);
      var y = amplitude / 3 + (amplitude - (sinValue + detailValue)) / 1.5;
      ctx.lineTo(x, y);
    }

    var extraX = width + step;
    var sinValueE = amplitude * Math.sin(frequency * extraX + phase) / 2;
    var detailValueE = amplitude / 3 * Math.sin(2 * frequency * extraX);
    var yE = amplitude / 3 + (amplitude - (sinValueE + detailValueE)) / 1.5;
    ctx.lineTo(extraX, yE);
    ctx.lineTo(width, 0);
    ctx.fillStyle = 'white';
    ctx.fill();
  }

  function animate() {
    phase += 0.02;
    phase %= width || (Math.PI * 2);
    drawWave();

    var now = Date.now();
    var timeSinceLast = now - lastScrollTime;

    if (timeSinceLast > 1000 && !isScrolling) {
      amplitude *= 0.995;
    }

    if (amplitude > 0.5 || isScrolling) {
      animationId = requestAnimationFrame(animate);
    } else {
      ctx.clearRect(0, 0, width, height);
      animationId = null;
    }
  }

  var lastScrollThrottle = 0;
  function handleScroll() {
    var now = Date.now();
    if (now - lastScrollThrottle < 16) return;
    lastScrollThrottle = now;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var delta = Math.abs(scrollTop - lastScrollTop);
    lastScrollTop = scrollTop;

    amplitude = Math.min(MAX_AMPLITUDE, Math.max(amplitude, delta * 0.2));
    lastScrollTime = Date.now();
    isScrolling = true;

    if (animationId === null) {
      animationId = requestAnimationFrame(animate);
    }

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      isScrolling = false;
    }, 100);
  }

  initCanvas();

  var resizeThrottle = null;
  window.addEventListener('resize', function() {
    clearTimeout(resizeThrottle);
    resizeThrottle = setTimeout(initCanvas, 200);
  });

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('touchmove', handleScroll, { passive: true });
  window.addEventListener('touchend', handleScroll, { passive: true });
})();


// ===== CONSTANT MENU WAVE (NavbarMenuWaves) =====
(function() {
  var canvas = document.getElementById('menu-wave');
  if (!canvas) return;

  var ctx = canvas.getContext('2d');
  var width = 0;
  var height = 80;
  var phase = 0;
  var animationId = null;
  var AMPLITUDE = 20;

  function updateSize() {
    width = window.innerWidth;
    canvas.width = width;
    canvas.height = height;
  }

  function drawMenuWave() {
    ctx.clearRect(0, 0, width, height);
    ctx.beginPath();

    var wavelength = width;
    var frequency = 2 * Math.PI / wavelength;

    ctx.moveTo(0, 0);
    for (var x = 0; x <= width; x++) {
      var sinValue = AMPLITUDE * Math.sin(frequency * x + phase) / 2;
      var detailValue = AMPLITUDE / 3 * Math.sin(2 * frequency * x);
      var y = AMPLITUDE / 3 + (AMPLITUDE - (sinValue + detailValue)) / 1.5;
      ctx.lineTo(x, y);
    }

    ctx.lineTo(width, 0);
    ctx.fillStyle = 'white';
    ctx.fill();
  }

  function animateMenu() {
    phase += 0.05;
    phase %= Math.PI * 2;
    drawMenuWave();
    animationId = requestAnimationFrame(animateMenu);
  }

  updateSize();
  window.addEventListener('resize', updateSize);

  // Position menu-wave below navbar (80px) by default
  // When dropdown is open, position will be updated by theme.js
  animateMenu();
})();
